import React from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import { connect } from "react-redux";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import audioIcon from "../../assets/audio-icon.svg";
import { withRouter } from "react-router-dom";
import "./PdfEditArticleAVList.css";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { sendMediaRequestAction } from "../../redux/actions/editArticlePanel";
import { loadMediasRequestAction } from "../../redux/actions/pdfEditArticleAVList";

class PdfEditArticleAVList extends React.Component {
  constructor(props) {
    super(props);
    this.loadMedias = this.loadMedias.bind(this);
    this.imageClicked = this.imageClicked.bind(this);
  }

  imageClicked(media) {
    const { isPdf, article, history } = this.props;

    if (media.article != null) {
      if (media.article.id == null) {
        toast.error("media id null");
        return;
      }

      if (media.article.id !== article.id) {
        history.push(media.article.id);
      }

      return;
    }

    if (isPdf) {
      this.props.sendMediaRequestAction(
        media,
        article.book.id,
        article.id,
        toast
      );
    }
  }

  componentDidMount() {
    const { article } = this.props;

    if (article == null) {
      return;
    }

    this.loadMedias(article.book.id);
  }

  componentDidUpdate(prevProps) {
    const { article } = this.props;

    if (article == null) {
      return;
    }

    if (
      prevProps.article == null ||
      article.book.id !== prevProps.article.book.id
    ) {
      this.loadMedias(article.book.id);
    }
  }

  async loadMedias(issueID) {
    if (issueID == null) {
      return;
    }

    this.props.loadMediasRequestAction(issueID, toast);
  }

  render() {
    const { medias } = this.props;

    if (medias == null) {
      return (
        <div className="article_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    }

    let chunkArray = [];
    for (let i = 0; i < medias.length; i += 3) {
      let aChunk = medias.slice(i, i + 3);
      chunkArray.push(aChunk);
    }

    return (
      <Container className="pdf_video_thumb_container">
        {chunkArray.map((aChunkArray, idx) => {
          return (
            <React.Fragment key={idx}>
              <Row className="pdf_thumb_image">
                {aChunkArray.map(aMedia => {
                  let imageUri;
                  if (aMedia.mediaType === "audio") {
                    imageUri = audioIcon;
                  } else {
                    imageUri =
                      aMedia.thumbnail == null
                        ? ""
                        : `${process.env.REACT_APP_API_ROOT}artworks/${
                            aMedia.thumbnail.id
                          }/static/thumbnail`;
                  }

                  const disabled = aMedia.article != null;

                  return (
                    <Col key={aMedia.id} xs="4" sm="4" md="4" lg="3" xl="2">
                      <Image
                        style={{ opacity: disabled ? 0.3 : 1 }}
                        className="media_list_thumb"
                        src={imageUri}
                        thumbnail
                        onClick={() => this.imageClicked(aMedia)}
                      />
                      <div
                        className="pdf_video_thumb_title_container"
                        style={{ opacity: disabled ? 0.3 : 1 }}
                      >
                        <span className="pdf_video_thumb_title">
                          {aMedia.title}
                        </span>
                      </div>
                    </Col>
                  );
                })}
              </Row>
              <hr />
            </React.Fragment>
          );
        })}
      </Container>
    );
  }
}

const mapState = (state, ownProps) => {
  const { pdfEditArticleAVList } = state;

  return {
    medias: pdfEditArticleAVList.medias
  };
};

const mapDispatch = {
  sendMediaRequestAction,
  loadMediasRequestAction
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(PdfEditArticleAVList)
);
